import { SYNC_DELAY } from "@framework/constants";

export const useBlinkAnimation = (
  shouldBlinkBg: boolean,
  shouldBlinkBorder: boolean,
  bgColor: string,
  borderColor: string = "#222",
) => {
  const bgPart = bgColor.replace(/[^a-zA-Z0-9]/g, "");
  const borderPart = borderColor.replace(/[^a-zA-Z0-9]/g, "");

  const keyframeName = `blink_${bgPart}_${borderPart}_${shouldBlinkBg ? "1" : "0"}${shouldBlinkBorder ? "1" : "0"}`;

  const animation =
    shouldBlinkBg || shouldBlinkBorder ? `${keyframeName} 1s steps(1, end) ${SYNC_DELAY} infinite` : "none";

  const keyframes = {
    [`@keyframes ${keyframeName}`]: {
      "0%, 100%": {
        backgroundColor: bgColor,
        borderColor,
      },
      "50%": {
        backgroundColor: shouldBlinkBg ? "#ffffff" : bgColor,
        borderColor: shouldBlinkBorder ? "#ff0000" : borderColor,
      },
    },
  };

  return { animation, keyframes };
};
